const DB_NAME = 'TimboPerformance';
const DB_VERSION = 3;
const STORE_ADS = 'aggregatedAds';
const STORE_META = 'meta';
const STORE_ACTIONED = 'actionedFlags';
export const STORE_DAILY = 'dailyAds'; // v3.99.1 — per-day incremental cache

let dbInstance = null;

export function openDB() {
  if (dbInstance) return Promise.resolve(dbInstance);
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_ADS)) db.createObjectStore(STORE_ADS, { keyPath: 'storeKey' });
      if (!db.objectStoreNames.contains(STORE_META)) db.createObjectStore(STORE_META, { keyPath: 'key' });
      if (!db.objectStoreNames.contains(STORE_ACTIONED)) db.createObjectStore(STORE_ACTIONED, { keyPath: 'core_id' });
      if (!db.objectStoreNames.contains(STORE_DAILY)) db.createObjectStore(STORE_DAILY, { keyPath: 'date' });
    };
    req.onsuccess = (e) => { dbInstance = e.target.result; resolve(dbInstance); };
    req.onerror = (e) => reject(e.target.error);
  });
}

export async function saveAds(aggregatedAds) {
  const db = await openDB();
  const tx = db.transaction([STORE_ADS], 'readwrite');
  const store = tx.objectStore(STORE_ADS);
  await new Promise((res, rej) => { const r = store.clear(); r.onsuccess = res; r.onerror = rej; });
  for (const ad of aggregatedAds) store.put({ ...ad, storeKey: `${ad.core_id}::${ad.adset_category}` });
  return new Promise((res, rej) => { tx.oncomplete = res; tx.onerror = rej; });
}

export async function loadAds() {
  const db = await openDB();
  return new Promise((res, rej) => {
    const tx = db.transaction([STORE_ADS], 'readonly');
    const req = tx.objectStore(STORE_ADS).getAll();
    req.onsuccess = () => res(req.result); req.onerror = () => rej(req.error);
  });
}

export async function setMeta(key, value) {
  const db = await openDB();
  return new Promise((res, rej) => {
    const tx = db.transaction([STORE_META], 'readwrite');
    tx.objectStore(STORE_META).put({ key, value });
    tx.oncomplete = res; tx.onerror = rej;
  });
}

export async function getMeta(key) {
  const db = await openDB();
  return new Promise((res, rej) => {
    const tx = db.transaction([STORE_META], 'readonly');
    const req = tx.objectStore(STORE_META).get(key);
    req.onsuccess = () => res(req.result?.value); req.onerror = () => rej(req.error);
  });
}

export async function markActioned(core_id) {
  const db = await openDB();
  return new Promise((res, rej) => {
    const tx = db.transaction([STORE_ACTIONED], 'readwrite');
    tx.objectStore(STORE_ACTIONED).put({ core_id, actioned_at: new Date().toISOString() });
    tx.oncomplete = res; tx.onerror = rej;
  });
}

export async function unmarkActioned(core_id) {
  const db = await openDB();
  return new Promise((res, rej) => {
    const tx = db.transaction([STORE_ACTIONED], 'readwrite');
    tx.objectStore(STORE_ACTIONED).delete(core_id);
    tx.oncomplete = res; tx.onerror = rej;
  });
}

export async function getActionedSet() {
  const db = await openDB();
  return new Promise((res, rej) => {
    const tx = db.transaction([STORE_ACTIONED], 'readonly');
    const req = tx.objectStore(STORE_ACTIONED).getAll();
    req.onsuccess = () => res(new Set(req.result.map(r => r.core_id))); req.onerror = () => rej(req.error);
  });
}

export async function clearActioned() {
  const db = await openDB();
  return new Promise((res, rej) => {
    const tx = db.transaction([STORE_ACTIONED], 'readwrite');
    tx.objectStore(STORE_ACTIONED).clear();
    tx.oncomplete = res; tx.onerror = (e) => rej(e.target.error);
  });
}
